import type { DropDownProps } from '@bluevision/components/types/components/DropDown/type';
import { DropDown } from '@bluevision/components';
import React from 'react';

export type HeaderDropdownProps = {
  overlayClassName?: string;
  overlay: React.ReactNode | (() => React.ReactNode);
  placement?: 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topCenter' | 'topRight' | 'bottomCenter';
} & Omit<DropDownProps, 'overlay'>;

const HeaderDropdown: React.FC<HeaderDropdownProps> = ({
  overlayClassName: cls,
  overlay,
  ...restProps
}) => (
  <DropDown
    overlayClassName={cls}
    overlay={typeof overlay === 'function' ? overlay() : overlay}
    {...restProps}
  />
);

export default HeaderDropdown;
